import React from 'react';

import styles from "./Layers.module.scss";
import ImageWrapper from "components/imageWrapper/ImageWrapper";

const CacheSquare = (props) => {

    return (
        <>
            <div aria-hidden={true} className={styles.midChildWrapper}>
                <ImageWrapper className={`${styles.bgLayer} ${styles.cache_midSquare}`}
                              set={{
                                  400:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex400.png',
                                  800:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex800.png',
                                  default:'https://msobd-storage.azureedge.net/images/profile_cache/bg-square.png'}}
                              alt={'Square'}/>
                <div aria-hidden={true} className={styles.bonusChildWrapper}>
                    <ImageWrapper className={`${styles.bgLayer} ${styles.cache_bonusSquare}`}
                                  set={{
                                      400:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex400.png',
                                      800:'https://msobd-storage.azureedge.net/images/profile_cache/bg-squarex800.png',
                                      default:'https://msobd-storage.azureedge.net/images/profile_cache/bg-square.png'}}
                                  alt={'Square'}/>
                </div>
            </div>
        </>
    );

};

export default CacheSquare
